import {
    EuiButtonIcon,
    EuiHeader,
    EuiHeaderSection,
    EuiHeaderSectionItem,
} from '@elastic/eui'
import { logout, setColorMode } from '@store/auth'

import HeaderNavMenu from './nav/HeaderNavMenu'
import HeaderUserMenu from './HeaderUserMenu'
import { getMsalInstance } from '@services/auth/msal.service'
import logo from '@assets/logo_default_dark_sm.png'
import logoIcon from '@assets/logo_icon.png'
import { useAppDispatch } from '@hooks/store'
import { useAuth } from '@hooks/auth'
import { useNavigate } from 'react-router-dom'
import { useTranslation } from 'react-i18next'

const Header = () => {
    const { user, colorMode } = useAuth()
    const { t } = useTranslation(['common'])
    const dispatch = useAppDispatch()
    const navigate = useNavigate()
    const isDarkTheme = colorMode === 'dark'

    const handleLogout = async () => {
        if (user?.isAzureToken) {
            const msalInstance = getMsalInstance()
            await msalInstance?.initialize()
            if (msalInstance) await msalInstance.logoutPopup()
        }

        dispatch(logout())
        navigate('/auth/login')
    }

    const handleThemeChange = () => {
        dispatch(setColorMode(isDarkTheme ? 'light' : 'dark'))
    }

    return (
        <EuiHeader position="fixed" theme="dark">
            <EuiHeaderSection>
                <EuiHeaderSectionItem>
                    <picture style={{ paddingRight: '1rem' }}>
                        <source media="(min-width: 500px)" srcSet={logo} />
                        <img
                            src={logoIcon}
                            alt="Logo"
                            style={{
                                maxHeight: '40px',
                            }}
                        />
                    </picture>
                </EuiHeaderSectionItem>
            </EuiHeaderSection>
            <EuiHeaderSection>
                <EuiHeaderSectionItem>
                    <HeaderNavMenu />
                </EuiHeaderSectionItem>
            </EuiHeaderSection>
            <EuiHeaderSection side="right">
                <EuiHeaderSectionItem>
                    <EuiButtonIcon
                        iconType={isDarkTheme ? 'sun' : 'moon'}
                        color="warning"
                        title={
                            isDarkTheme
                                ? t('common:switch_light_theme')
                                : t('common:switch_dark_theme')
                        }
                        size="m"
                        aria-label={
                            isDarkTheme
                                ? t('common:switch_light_theme')
                                : t('common:switch_dark_theme')
                        }
                        style={{ color: isDarkTheme ? '#ffc414' : '#fff' }}
                        onClick={handleThemeChange}
                    />
                </EuiHeaderSectionItem>
                {user && (
                    <EuiHeaderSectionItem>
                        <HeaderUserMenu
                            displayName={`${user?.firstName} ${user?.lastName}`}
                            onLogout={handleLogout}
                        />
                    </EuiHeaderSectionItem>
                )}
            </EuiHeaderSection>
        </EuiHeader>
    )
}

export default Header
